import { axios } from './axios';

export function getEntityValue(entityName, ids) {
    if (!entityName || !ids) return Promise.reject('Entity and id is needed');
    return axios.get(`/search/v1/fuzzySearch/${entityName}/values?ids[]=${ids.join(',')}`);
}
